import React, { Component } from "react";
import {   Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { connect } from "react-redux";
import {Field, reduxForm } from "redux-form";
import { renderInput } from "../common/renderinput";
import Banner from "../common/banner";
import {Loading,LoadingDone,Reset,Success,Error} from "../../actions/loading"


const divStyle = {
    backgroundColor: '#fff',
    marginTop:'14px'
};
const padStyle = {
    paddingTop: '5px', paddingLeft : '0px'
};
class ChangePasswordForm extends Component {

    constructor(...args) {
        super(...args);
        this.state = {
            display:this.props.isOpen
        };
    }


    closeBanner = () => {

    };
    toggle = (val) => {
        this.setState({...this.state, display : !val})
    }
    submit = (values) => {

      this.props.session.cognitoUser.changePassword(values.OldPassword,
        values.NewPassword, (err,res)=> {
          if (err) 
          {
            this.props.Error(err.message)
          }
          else 
            this.props.Success('Password changed successfully!')
        })

        //  var res =  this.props.changePassword(
        //             this.props.session.cognitoUser,
        //             values.OldPassword,
        //             values.NewPassword
        //     );
        //     console.log(res);
    }
    componentDidMount() {
    }
    closemodal =()=>{
        this.props.close()
    }
    render() {
        return (
          <>
            <div>
              <Modal
                isOpen={this.state.display}
                toggle={this.toggle}
                contentClassName="custom-modal-style"
              >
                <form
                  onSubmit={this.props.handleSubmit(this.submit)}
                  style={{ marginLeft: "0%", marginRight: "5%" }}
                >
                  <ModalHeader>change password</ModalHeader>
                  <ModalBody>
                    {this.props.loading.showBanner && (
                      <Banner
                        Close={this.props.Reset}
                        message={this.props.loading.message}
                        IsSuccess={this.props.loading.isSuccess}
                      />
                    )}
                    <div className="form-row col-12" style={padStyle}>
                        <div className="col-12" style={divStyle}>
                        <Field
                          name="OldPassword"
                          component={renderInput}
                          label="OldPassword"
                        />
                        </div>
                        <div className="col-12" style={divStyle}>
                        <Field
                          name="NewPassword"
                          component={renderInput}
                          label="NewPassword"
                        />
                        </div>
                    </div>
                  </ModalBody>
                  <ModalFooter>
                    <Button color="primary" type="submit">
                    <span>Save</span>
                    </Button>
                    <Button color="secondary" onClick={this.closemodal}>
                    <span>Cancel</span>
                    </Button>
                  </ModalFooter>
                </form>
              </Modal>
            </div>
          </>
        );
    }

}
const validate = (formValues) => {
    const errors = {};
    if (!formValues.OldPassword) {
        errors.OldPassword = "Old Password is required";
    }
    if (!formValues.NewPassword) {
        errors.NewPassword = "New Password is required";
    }
    return errors;
}
var changePasswordForm = reduxForm({
    form: 'ChangePasswordForm',
    validate
})(ChangePasswordForm);

changePasswordForm = connect(
    state => ({
        session: state.session.session,
        loading : state.loading
    }),{LoadingDone,Loading,Success,Error,Reset}
)(changePasswordForm);

export default changePasswordForm;